import React from 'react';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../../components/SEO';

/** Confirmation after cash pass checkout — pass appears in the wallet after the host activates it. */
const PassPurchasePendingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t('passes.purchasePendingTitle', 'Cash purchase requested')} noindex />
      <Box sx={{ maxWidth: 560, mx: 'auto', p: { xs: 2, sm: 4 } }}>
        <Card elevation={3} sx={{ p: { xs: 3, sm: 4 }, textAlign: 'center' }}>
          <Stack spacing={2} alignItems="center">
            <ScheduleRoundedIcon color="warning" sx={{ fontSize: 56 }} />
            <Typography variant="h5" fontWeight={700}>
              {t('passes.purchasePendingTitle', 'Cash purchase requested')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t(
                'passes.purchasePendingBody',
                'Pay on site when you visit. Your pass will appear in your wallet after the host activates it.',
              )}
            </Typography>
            <Button component={RouterLink} to="/user/passes" variant="contained" size="large" sx={{ mt: 1 }}>
              {t('passes.viewMyPasses', 'View my passes')}
            </Button>
          </Stack>
        </Card>
      </Box>
    </>
  );
};

export default PassPurchasePendingPage;
